module.exports = {
	"abort_transformation": "Abortar transformación",
	"actions": "Aacciones",
	"activity": "Actividad",
	"add_layer": "Añadir capa",
	"add_new_text_element": "Añadir nuevo elemento de texto",
	"add_to_collection": "Añadir a la colección",
	"add_to_dashboard": "Añadir al tablero",
	"admin": "admin",
	"advanced": "Avanzado",
	"aggregation_method": "Método de agregación",
	"aggregation_type": "Tipo de agregación",
	"aggregation": "Agregación",
	"akvo_flow": "Akvo Flow",
	"akvo_rsr": "Akvo RSR",
	"all_changes_saved": "Todos los cambios guardados",
	"all": "Todo",
	"antimeridian": "Meridiano 180",
	"apply": "Aplicar",
	"area": "Área",
	"ascending": "Ascendente",
	"authentication_issue": "Existe un problema verificando su identidad",
	"autodetect_column_types": "Detectar tipos de datos automáticamente",
	"average": "Promedio",
	"back_to_layers": "Volver a capas",
	"back": "volver",
	"bar": "Barra",
	"base_map": "Mapa base",
	"blank_dashboard_help_text": "Haga clic en una visualización de la lista de visualizaciones para añadirla al tablero",
	"bottom": "Parte inferior",
	"bubble": "Bubble",
	"bucket_column": "Columna cubo",
	"bulk_column_editor": "Editor de columnas en masa",
	"bulk_row_editor": "Editor de filas en masa",
	"cancel": "Cancelar",
	"categories_cant_be_empty": "Las categorias no pueden quedar vacías",
	"categories_count": "{count} {count, plural, one {Categoría} other {Categorías}}",
	"categories_must_be_unique": "Categorias deben ser unicas",
	"category": "Categoría",
	"cell_as_percentage_of_column": "Celda como porcentaje de columna",
	"cell_as_percentage_of_row": "Celda como porcentaje de fila",
	"cell_as_percentage_of_table_total": "Celda como porcentaje del total de la tabla",
	"change_case": "Cambiar caso",
	"change_datatype_for": "Cambiar tipo de datos de {title}",
	"change_datatype_to": "Cambiar tipo de datos a",
	"choose_a_column_to_filter_by": "Elige una columna para filtrar por",
	"choose_a_filter_operation": "Elige una operación de filtro",
	"choose_a_match_method": "Elige un método de coincidencia",
	"choose_aggregation_type": "Elija tipo de agregación",
	"choose_dataset": "Elija set de datos",
	"choose_how_cells_are_displayed": "Elija cómo se muestran las celdas",
	"circle": "Círculo",
	"clear_filter": "Borrar filtro",
	"close": "Cerrar",
	"collection_name": "Nombre de la colección",
	"collections": "Colecciones",
	"color_coding_column": "Columna de código de color",
	"color": "Color",
	"colors_for_title": "Colores ({title})",
	"column_filter_by": "Columna para filtrar por",
	"column_title_geo": "Título de columna geográfica",
	"columns_title": "Título de las columnas",
	"columns": "Columnas",
	"combine_columns": "Combinar columnas",
	"combine_transform_description": "Combinar columnas {firstTitle} y {secondTitle} en \"{newColumnTitle}\"",
	"combine": "Combinar",
	"comma": "Coma",
	"contact": "Contacto",
	"contains": "contiene",
	"count_unique": "Cuenta única",
	"count": "Contar",
	"create_visualization": "Crear visualización",
	"create": "Crear",
	"created_by": "Creado por",
	"creating": "Creando",
	"dashboard": "Tablero",
	"dashboards": "Tableros",
	"data_file": "Archivo de datos",
	"data_group_intro_0_body": "Los set de datos ahora se dividen en grupos de datos para facilitar la limpieza y la transformación. Obtenga una mejor visión general independientemente del tamaño del set de datos. Un grupo de datos dedicado contiene todas las columnas transformadas para mantener las cosas organizadas.",
	"data_group_intro_0_footer": "En el futuro, esta nueva vista permitirá datos de grupos de datos repetidos y se convertirá en la predeterminada.",
	"data_group_intro_0_header": "Experimente la nueva vista del set de datos",
	"data_group_intro_1": "Los grupos de datos se basan en los grupos de preguntas de Flow y los metadatos de envío. Lumen maneja todas las relaciones de datos entre los grupos al transformar y visualizar datos.",
	"data_group_intro_2": "Seleccione cualquier grupo de datos para mostrar sus datos en la cuadrícula.",
	"data_group_intro_3": "Puede alternar entre vista nueva y antigua aquí.",
	"data_groups": "Grupos de datos",
	"data_has_column_headers": "Los datos tienen encabezados de columna",
	"data_last_updated": "Última actualización de los datos",
	"data": "Datos",
	"dataset_filters": "Filtros de set de datos",
	"dataset_name": "Nombre del set de datos",
	"dataset": "Set de datos",
	"datasets": "Sets de datos",
	"date": "Fecha",
	"default": "Defecto",
	"delete_column": "Eliminar columna",
	"delete_row": "Eliminar fila",
	"delete": "Eliminar",
	"deleted_column": "Borrar columna: {title}",
	"derive_column_category": "Categoría de Columna (TEXTO)",
	"derive_column_javascript": "Via JavaScript",
	"derive_column": "Derivar la columna",
	"derive": "Derivar",
	"derived_category_transform_description": "Derivada \"{newColumnTitle}\" desde {columnSource} ({columnType})",
	"derived_column_title": "Título de columna derivada",
	"derived_transform_description": "Derivar {newColumnTitle} utilizando {code}",
	"descending": "Descendente",
	"donut": "Rosquilla",
	"download": "Descargar",
	"drop_file_anywhere": "Arrastrar y soltar fichero en cualquier sitio para subirlo",
	"dropbox": "Dropbox",
	"duplicate": "Duplicado",
	"email_verified_error": "Necesita verificar su dirección de email, por favor revise su buzón de correo y haga click en el enlace de verificación",
	"email": "Email",
	"enter_a_number": "Introduzca un número",
	"enter_password_8": "Por favor, introduzca una contraseña con al menos 8 caracteres.",
	"enter_password": "Por favor, introduzca una contraseña.",
	"enter_text_here": "Introduzca el texto aquí",
	"exactly_matches": "Exactamente coincide",
	"export": "Exportar",
	"extract_multiple_global_error": "Surgió un error inesperado!, por favor contacte con el administrador del sistema",
	"extract_multiple_log": "Extraer múltiples valores desde: {extractedColumnTitle} a: {newColumnsTitle}",
	"extract_multiple_not_found_error": "Hemos encontrado un problema con los datos relacionados con esta columna múltiple",
	"extract_multiple": "Extraer múltiples valores",
	"extract": "Extraer",
	"file_has_column_headers": "El fichero tiene encabezados de columna",
	"file_name": "Nombre del archivo",
	"file_project": "Archivo / Proyecto",
	"fill": "Rellenar",
	"filter_column": "Columna de filtro {title}",
	"filter_list_by_title": "Filtrar lista por título",
	"filter_match_method": "Método de coincidencia de filtro",
	"filter_match_value": "Valor de coincidencia de filtro",
	"filter_operation": "Operación de filtro",
	"filter_text": "Filtrar texto",
	"filter_visualisations_by_dataset": "Filtrar visualizaciones por conjunto de datos",
	"filter": "Filtrar",
	"filters": "Filtros",
	"first_name": "Nombre",
	"flow_application_url": "URL de la aplicación Flow",
	"following_filter_dash_will_be_deleted": "El siguiente tablero ya no será filtrado por el conjunto de datos a borrar",
	"following_filters_dash_will_be_deleted": "Los siguientes tableros ya no serán filtrados por el conjunto de datos a borrar",
	"following_visualisation_will_be_deleted": "La siguiente visualización será borrada",
	"following_visualisations_will_be_deleted": "Las siguientes visualizaciones serán borradas",
	"form_submissons": "formularios enviados",
	"generate_geopoints": "Generar geografía",
	"generate": "Generar",
	"geo_location": "Ubicación geográfica",
	"geo_shape": "Forma geográfica",
	"geo_transform_description": "Se ha generado la columna {columnTitleGeo} a partir de las columnas {columnTitleLat} y {columnTitleLong}",
	"geopoint_column": "Columna de geopoint",
	"geopoint": "Geopoint",
	"geoshape_column": "Columna de geoshape",
	"geoshape_labels": "Etiquetas de geoshape",
	"geoshape": "Forma geográfica",
	"geotiff": "GeoTIFF",
	"github": "Github",
	"google_drive": "Google Drive",
	"got_it": "Entendido",
	"gradient": "Gradiente",
	"greenwich": "Greenwich",
	"group": "Grupo",
	"having_trouble_signing_up": "¿Sigue teniendo problemas para registrarse?",
	"hyphen": "Guión",
	"if_cell_format_is_invalid": "Si el formato de celda no es válido",
	"if_transformation_fails": "Si la transformación falla",
	"Image": "Imagen",
	"import": "Importar",
	"invalid_expression": "Expresión inválida",
	"invalid_filter": "Esta visualización contiene un filtro inválido y no puede ser representada.",
	"is_after": "es después",
	"is_before": " es antes",
	"is_empty": "es vacío",
	"is_equal_to": "es igual a",
	"is_greater_or_equal_to": "es mayor que o igual a",
	"is_greater_than": "es mayor que",
	"is_higher_than": "es mayor que",
	"is_less_or_equal_to": "es igual que o igual a",
	"is_less_than": "es menor que",
	"is_lower_than": "es menor que",
	"javascript_code": "Código Javascript",
	"js_helptext": "Las columnas derivadas son fórmulas escritas utilizando un subset de Javascript dónde se permite una sola expresión y las columnas son referenciadas como {columnSyntax} o alternativamente si el título es un identificador de Javascript válido: {title}.",
	"keep_rows_in_which": "mantener las filas en las cuales",
	"label": "Etiqueta",
	"last_modified": "Ultima modificación",
	"last_name": "Apellido",
	"latitude_column": "Columna de latitud",
	"layer_type": "Capa tipo",
	"layers": "Capas",
	"leave_cell_empty": "Dejar la celda vacía",
	"left": "Izquierda",
	"legend_category_order": "Orden de categorías",
	"legend_order_auto_mode": "Automático",
	"legend_order_custom_mode": "Personalizado",
	"legend_position_auto": "Automático",
	"legend_position_bottom": "Debajo",
	"legend_position_left": "Izquierda",
	"legend_position_right": "Derecha",
	"legend_position_top": "Encima",
	"legend_position": "Posición Leyenda",
	"legend_title": "Título de la leyenda",
	"legend": "Leyenda",
	"library": "Catálogo",
	"line": "Línea",
	"link": "Enlace",
	"logout": "cerrar sesión",
	"longitude_column": "Columna de longitud",
	"lower_quartile": "Cuartil inferior",
	"main": "Principal",
	"map": "Mapa",
	"max_value": "Máximo: {val}",
	"max": "Máximo",
	"mean": "Media",
	"median": "Mediana",
	"merge_datasets": "Combinar sets de datos",
	"merged_dataset": "Unir columnas desde {title}",
	"metadata": "Metadata",
	"metric_column": "Columna métrica",
	"metric_columns": "Columnas métricas",
	"min_value": "Mínimo: {val}",
	"min": "Mínimo",
	"misc": "Otras opciones",
	"multiple": "Múltiples valores",
	"must_choose_bucket_column_first": "Debe elegir primero la columna cubo",
	"must_choose_x_axis_column_first": "Debe elegir primero la columna del eje x",
	"name": "Nombre",
	"new_category_column": "Nueva Categoría de Columna",
	"new_collection": "Nueva colección",
	"new_column_title": "Nuevo título de columna",
	"new_column_type": "Nuevo tipo de columna",
	"new_dataset": "Nueva set de datos",
	"new_filter": "Nuevo filtro",
	"new_serie": "Nueva serie",
	"next": "Siguiente",
	"no_filter_dashboards_depend_on_dataset": "Ningún filtro de tablero depende de este conjunto de datos",
	"no_visualisations_depend_on_dataset": "Ninguna visualización depende de este conjunto de datos",
	"no_visualisations_match_your_filter": "Ninguna visualización coincide con tu filtro",
	"no_visualisations_to_show": "Ninguna visualización a mostrar",
	"none": "Ninguna",
	"not_affected_by_applied_filters": "No afectada por los filtros aplicados",
	"not_contains": "no contiene",
	"number_of_buckets_to_show": "Número de cubos a mostrar",
	"number_of_decimal_places": "Número de decimales",
	"number": "Número",
	"or": "o",
	"outline": "Esquema",
	"overflow": "Desborde",
	"paste_url_here": "Pegar url aquí",
	"pattern_subtitle": "Especifica cualquier carácter (o secuencia de caracteres) para dividir la columna",
	"pattern_suggestion": "Sugerencias para '{columnTitle}': {recommendations}",
	"pattern": "Separador",
	"pdf": "PDF",
	"pending": "Pendiente",
	"percentage_stack_bars": "Barras 100% apiladas",
	"pick_a_default_value": "Elegir valor por defecto",
	"pie": "Pastel",
	"pivot table": "Tabla pivote",
	"pivot_help_text": "Escoje una columna y una fila pivote para utilizar agregaciones distintas del recuento.",
	"please_edit_visualisation": "Por favor edite la visualización o añada un filtro.",
	"png": "PNG",
	"point_size": "Tamaño de punto",
	"polararea": "Área Polar",
	"popup_label_column": "Columna de etiqueta emergente",
	"popup_label": "Etiqueta emergente",
	"popup": "Popup",
	"prefix": "Nuevo prefijo de columna",
	"previous": "Previo",
	"raster": "Raster",
	"remove_collection": "Eliminar de {title}",
	"remove_double_space": "Eliminar el espacio doble",
	"remove_leading_and_trailing_whitespace": "Eliminar los espacios en blanco",
	"remove_rows_in_which": "Quitar filtas en las cuales",
	"removed_double_space": "{title} espacio doble eliminado",
	"rename_column": "Renombrar columna",
	"rename": "Renombrar",
	"renamed_column": "Renombrado {from} a {to}",
	"request_permission_from_your_organisation_admin": "Solicite permisos al administrador de su organización.",
	"reselect_source_column": "Seleccione otra columna",
	"resources": "Recursos",
	"retry": "Volver a intentar",
	"reverse_geocode": "Geocodificación inversa",
	"right": "Derecha",
	"role": "Rol",
	"row_column_title": "Título de columna de fila",
	"row_column": "Columna de fila",
	"rows": "Filas",
	"rqg": "Múltiple",
	"satellite": "Satélite",
	"save_filter": "Guardar filtro",
	"save_your_dashboard_before_exporting": "Guarde su tablero antes de exportar",
	"save_your_dashboard_before_sharing": "Guarda el tablero antes de compartir",
	"save_your_visualisation_before_exporting": "Guarda la visualización antes de exportar",
	"save_your_visualisation_before_sharing": "Guarda la visualización antes de compartir",
	"save": "Guardar",
	"saving_failed_countdown": "No se pudo guardar. Intentándolo de nuevo ",
	"scatter": "Dispersar",
	"search_not_implemented_yet": "Búsqueda aún no implementada",
	"search": "Búsqueda",
	"select_a_color_coding_column": "Seleccionar una columna de datos para mapear los colores de punto",
	"select_a_column": "Selecciona una columna",
	"select_a_data_column_to_group_by": "Selecciona una columna de datos para agrupar por ella",
	"select_a_geopoint_column": "Seleccionar una columna de geopoint",
	"select_a_geoshape_column": "Seleccionar una columna de geoshape",
	"select_a_geoshape_label_column": "Seleccionar una etiqueta de columna de geoshape",
	"select_a_latitude_column": "Seleccionar una columna de latitud",
	"select_a_longitude_column": "Seleccionar una columna de longitud",
	"select_a_metric_column": "Selecciona una columna métrica",
	"select_a_popup_label_column": "Selecciona una columna de etiqueta emergente",
	"select_a_row_column": "Selecciona una columna de fila",
	"select_a_styling_dataset": "Seleccionar un set de datos de estilos",
	"select_a_styling_indicator_geopoint_column": "Seleccionar un indicador de estilos de columna de geopoint",
	"select_a_styling_indicator": "Seleccionar un indicador de estilos",
	"select_a_sub_bucket_column": "Selecciona una columna sub-cubo",
	"select_a_value_column": "Seleccione una columna",
	"select_aggregation_method": "Selecciona un método de agregación",
	"select_all": "Seleccionar todo",
	"select_another_metric_column": "Selecciona otra columna métrica",
	"select_column_lat": "Selecciona una columna de latitud",
	"select_column_long": "Selecciona una columna de longitud",
	"select_form": "Selecciona un formulario",
	"select_multiple_column": "Seleccione columna múltiple",
	"select_n_column": "Selecciona columna {idx}",
	"select_separator": "Selecciona un separador",
	"select_source_column": "Seleccionar columna de origen",
	"select_survey_or_folder": "Selecciona una encuesta o carpeta",
	"select_values_to_extract": "Seleccione valores a extraer",
	"select_values_to_group": "Seleccionar valores a agrupar",
	"select": "Selecciona",
	"set_dataset_columns_as_visualisation_filters": "Establecer columnas de conjunto de datos como filtros de visualización",
	"set_permissions": "Establecer permisos",
	"settings": "Ajustes",
	"share": "Compartir",
	"show_column_totals": "Mostrar totales de columna",
	"show_labels": "Mostrar etiquetas",
	"show_legend": "Mostrar leyenda",
	"show_row_totals": "Mostrar totales de fila",
	"show_rows_whose": "Mostrar filas cuyos",
	"size_label": "Etiqueta",
	"size": "Tamaño",
	"skip": "Omitir",
	"solid": "sólido",
	"sort": "Ordenar",
	"sorted_column": "title} ordenado {direction, select, ASC {ascendentemente} DESC {descendentemente}}",
	"source_column": "Columna de origen",
	"source_dataset": "Set de datos origen",
	"source": "Origen",
	"split_bars": "Barras de división",
	"split_bucket": "Dividir columna cubo",
	"split_column_log": "Dividir la columna '{extractedColumnTitle}', con el prefijo '{newColumnNamePrefix}' con el separador '{pattern}'",
	"split_column": "Dividir valores de columna",
	"square": "Cuadrado",
	"stack_bars": "Barras de pila",
	"street": "Calle",
	"styling_dataset": "Set de datos de estilos",
	"styling_indicator_geopoint_column": "Aplicar estilos de columna de geopoint",
	"styling_indicator": "Indicador de estilos",
	"sub_bucket_column": "Columna sub-cubo",
	"sub_bucket_method": "Método sub-cubo",
	"sum": "Suma",
	"switch_view": "Cambiar vista",
	"terrain": "Terreno",
	"text": "Texto",
	"theme": "Tema",
	"to_lowercase_label": "A minúsculas",
	"to_lowercase": "{title} a minúsculas",
	"to_titlecase_label": "A titulizar",
	"to_titlecase": "{title} a titulizar",
	"to_try_with_another_account": "para probar con otra cuenta",
	"to_uppercase_label": "A mayúsculas",
	"to_uppercase": "{title} a mayúsculas",
	"too_many_visualisation_elements": "Esta visualización no puede mostrarse porque tiene {count} elementos. El número máximo de elementos es {max}.",
	"top": "Parte superior",
	"transform": "Transformar",
	"transformation_log": "Registro de transformación",
	"transformations": "Transformaciones",
	"triangle": "Triángulo",
	"trimmed_whitespace": "{title} recortado espacios en blanco",
	"type_javascript_expression_here": "Escribe una expresión Javascript aquí",
	"uncategorized_values": "Valores no categorizados",
	"uncategorized": "Sin categorizar",
	"undo": "Deshacer",
	"unique_values_count": "{count} {count, plural, one {Único valor} other {únicos valores}}",
	"unsaved_changes": "Cambios no guardados",
	"untitled_collection": "Colección sin título",
	"untitled_dashboard": "Tablero sin título",
	"untitled_layer": "Capa {count} sin título",
	"untitled_visualisation": "Visualización sin título",
	"update": "Actualizar",
	"upper_quartile": "Cuartil superior",
	"user": "Usuario",
	"users": "Usuarios",
	"using_sampled_data": "Usar datos de muestra",
	"value_column": "Columna de valor",
	"value_contains": "El valor contiene",
	"value_display": "Visualización del valor",
	"value_is": "El valor es",
	"view_details": "Ver detalles",
	"visualisation_type": "Tipo",
	"visualisation": "Visualización",
	"visualisations_that_can_be_filtered": "Visualizaciones que pueden ser filtradas por el conjunto de datos seleccionado",
	"visualisations": "Visualizaciones",
	"visualise": "Visualizar",
	"whitespace": "Espacio en blanco",
	"world_bank": "Banco Mundial",
	"x_axis_label": "Etiqueta del eje x",
	"x_axis": "Eje x",
	"y_axis_label": "Etiqueta del eje y",
	"y_axis": "Eje y",
	"yikes": "Caramba!",
	"you_need_permission_to_access": "Necesita permisos para acceder"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/es.json
// module id = 354
// module chunks = 11 12